function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 *
 * @param {node} parent
 * @returns {void}
 * This function opens the side cart popup when the checkout button is clicked.
 * It checks if the parent element exists and if the checkout button is present.
 * If both conditions are met, it adds a click event listener to the checkout button
 */
var openPopup = function openPopup(parent) {
  var _parent$closest;
  if (!parent) return;
  var checkoutBtn = (_parent$closest = parent.closest('#site-cart-sidebar')) === null || _parent$closest === void 0 ? void 0 : _parent$closest.querySelector('.js-sidecart-popup');
  if (!checkoutBtn) return;
  checkoutBtn.addEventListener('click', function (e) {
    parent.open(function () {
      var sidecart = document.querySelector('#site-cart-sidebar');
      if (sidecart) sidecart.style.overflow = 'hidden';
    });
  }, {
    once: true
  });
};

/**

 * @returns {void}
 * This function triggers changes in the side cart popup.
 */
window.triggerEventChanges = function () {
  var sidecartPopup = document.querySelector('#sidecart-popup');
  var cards = _toConsumableArray(sidecartPopup.querySelectorAll('.product-variant'));
  if (!cards.length) return;
  cards.forEach(function (card) {
    var input = card.querySelector('.product-variant__item:not(.hide-variant) input[type="radio"]');
    if (!input) return;
    var event = new Event('change', {
      bubbles: true
    });
    input.checked = true;
    input.dispatchEvent(event);
  });
};

/**
 *
 * @param {*} popup
 * When user add upsell product to cart, redirect to checkout page.
 */
window.checkoutRedirect = function (popup) {
  if (popup) {
    window.location.href = '/checkout';
  }
};
document.addEventListener('DOMContentLoaded', function () {
  var sidecartPopup = document.querySelector('#sidecart-popup');
  if (!sidecartPopup) return;
  openPopup(sidecartPopup);
});